import React, { useState } from 'react';
import NotFoundPage from '../pages/NotFoundPage';

// Error boundary wrapper for routes that can 404
export const RouteErrorWrapper = ({ children }) => {
  const [hasError, setHasError] = useState(false);

  // Method to be called by child components when they detect a 404
  const handleNotFound = () => {
    setHasError(true);
  };

  if (hasError) {
    return <NotFoundPage />;
  }

  // Clone children and pass the handleNotFound method
  return React.cloneElement(children, { onNotFound: handleNotFound });
}; 